export default __webpack_public_path__ + "static/media/qr-code.e4de3f4d.svg";